import React from 'react';

function FixPassword() {
  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    const data = new FormData(form);
    const pass1 = data.get("pass1");
    const pass2 = data.get("pass2");

    if (pass1 !== pass2) {
      alert("הסיסמאות אינן תואמות");
      return;
    }

    const jsonData = {
      pass1,
      pass2,
    };

    fetch("/fixpassword", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isFix) {
          alert("הסיסמה שונתה בהצלחה!");
          window.location = "/login";
        } else {
          alert(res.err);
        }
      });
  }

  return (
    <div className="container mt-5" dir="rtl">
      <div className="row justify-content-center">
        <div className="col-md-6">
          <div className="card shadow p-4">
            <h3 className="text-center mb-4">שחזור סיסמה</h3>
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">סיסמה חדשה</label>
                <input
                  type="password"
                  name="pass1"
                  className="form-control"
                  minLength="6"
                  required
                />
              </div>
              <div className="mb-3">
                <label className="form-label">אימות סיסמה</label>
                <input
                  type="password"
                  name="pass2"
                  className="form-control"
                  minLength="6"
                  required
                />
              </div>
              <div className="d-grid">
                <button type="submit" className="btn btn-primary">
                  שליחה
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FixPassword;
